// Phase 85.A.127 — Upload Progress Bar dùng chung.
// Style đồng bộ với HLS Jobs Dashboard: gradient amber→emerald, label %.
// Dùng cho cả user upload (RatingVideoUploadModal) lẫn admin upload
// (AdminAthleteVideosSection) — thay cho 2 UI cũ khác nhau.
import { Spinner, CheckCircle } from "@phosphor-icons/react";

export default function UploadProgressBar({
  pct,
  label,
  stage = "uploading", // "uploading" | "analyzing" | "done" | "error"
  testId = "upload-progress",
}) {
  const safePct = Math.max(0, Math.min(100, Number(pct) || 0));
  const isDone = stage === "done" || safePct >= 100;
  return (
    <div
      className="rounded-2xl border border-amber-400/30 bg-amber-500/5 px-3 py-2.5 space-y-2 backdrop-blur"
      data-testid={testId}
    >
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-1.5 min-w-0">
          {isDone ? (
            <CheckCircle size={13} weight="fill" className="text-emerald-300 shrink-0" />
          ) : (
            <Spinner size={13} weight="bold" className="text-amber-300 shrink-0 animate-spin" />
          )}
          <span
            className="text-[11.5px] font-bold text-white/85 truncate"
            data-testid={`${testId}-label`}
          >
            {label || (isDone ? "Hoàn tất!" : "Đang xử lý…")}
          </span>
        </div>
        <span
          className={`text-[12px] font-black tabular-nums ${
            isDone ? "text-emerald-200" : "text-amber-200"
          }`}
          data-testid={`${testId}-pct`}
        >
          {Math.round(safePct)}%
        </span>
      </div>
      <div className="h-1.5 rounded-full bg-white/[0.08] overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-amber-400 to-emerald-400 transition-all duration-500"
          style={{ width: `${Math.max(2, safePct)}%` }}
          data-testid={`${testId}-fill`}
        />
      </div>
    </div>
  );
}
